<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div class="float-lg-left col-lg-8">
        <div id="accordionFilter" class="content">
          <div class="card">
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                 data-parent="#accordionFilter">
              <div class="card-body">
                <form>
                  <em-filter :entity="modelName" ref="emListFilter"
                             @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div id="sithMesMstShiftTeamResultTable" class="content">
          <div class="card my-1">
            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                 data-parent="#accordionResult">
              <div class="card-body">
                <em-table :entity="modelName" withCustomRowActions
                          ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                  <template slot="customRowActions" slot-scope="customRowScope">
                    <b-button-group>
                      <em-button type="gotoChild"
                                 :class="toUserHolderClass(customRowScope.row.id)"
                                 customLabel="用户"
                                 customIcon=""
                                 showName
                                 @click="getShiftTeamUserTreeNodes(customRowScope.row.id)">
                      </em-button>
                    </b-button-group>
                  </template>
                </em-table>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="float-lg-right col-lg-4">
        <em-z-tree v-if="toUsers" ref="shiftTeamUserEmZTree" :nodeAppender="appendIcon2UserNodes"
                   :treeNodes="shiftTeamUserTreeNodes" :chkboxType="chkboxType"
                   checkEnable>
        </em-z-tree>
        <div class="row">
          <div class="col-lg-12 align-self-end">
            <div class="float-lg-right">
              <em-button key="userSave" v-if="toUsers" type="save" show-name
                         v-bind:class="'btn btn-primary'"
                         v-on:click="saveShiftTeamUsers"></em-button>
              <em-button key="userCancel" v-if="toUsers" type="cancel" show-name
                         v-bind:class="'btn btn-outline-secondary mr-1'"
                         v-on:click="getShiftTeamUserTreeNodes(selectShiftTeamId)"></em-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2020-09-29 18:15:55

import emCommonListMixin from "@/mixin/em/common/list";
import emRouteHelperMixin from "@/mixin/em/helper/route";
import EmZTree from "@/components/em/EmZTree";
import commonViewsUtil from "@/utils/commonViewsUtil";
import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "sithMesMstShiftTeamListView",
  mixins: [emCommonListMixin, emRouteHelperMixin, EmCommonApi],
  components: {EmZTree},
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      toUsers: false,
      shiftTeamUserTreeNodes: [],
      selectShiftTeamId: -1,
      userPrefix: "user_",
      deptPrefix: "dept_",
      chkboxType: {"Y": "s", "N": "s"} //父节点可以连带子节点，子节点不连带父节点
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    }
  },
  methods: {
    getShiftTeamUserTreeNodes(shiftTeamId) {
      //设置当前选中shiftTeamId，保存时要用到
      this.selectShiftTeamId = shiftTeamId

      let url = this.$_emApiMixin_entityBaseApi("sithMesMstShiftTeamUser")
          + `/shiftTeamUserTree?shiftTeamId=${shiftTeamId}`
      this.$_emApiMixin_get(url)
          .then(data => {
            this.shiftTeamUserTreeNodes = data
            this.showShiftTeamUserTree()
          });
    },
    showShiftTeamUserTree() {
      this.toUsers = true;
    },
    saveShiftTeamUsers() {
      if (this.selectShiftTeamId === -1) {
        commonViewsUtil.showWarning(this, "保存班组与用户关系,请先在左侧选择需要班组")
        return;
      }
      let url = this.$_emApiMixin_entityBaseApi("sithMesMstShiftTeamUser") + "/shiftTeamUserTree"
      this.$_emApiMixin_put(url, {
            shiftTeamId: this.selectShiftTeamId,
            userIds: this.getUserIds(this.$refs['shiftTeamUserEmZTree'].getCheckedNodes())
          }
      ).then(response => commonViewsUtil.showSuccess(this, "保存班组用户,操作成功"))
    },
    getUserIds(userNodes) {
      var v = "";
      for (var i = 0; i < userNodes.length; i++) {
        if (userNodes[i].id.startsWith(this.userPrefix)) {
          v += "," + userNodes[i].userId;
        }
      }
      return v.length > 0 ? v.substring(1) : v;
    }
    ,
    appendIcon2UserNodes(roleUserTreeNode) {
      let userPrefix = "user_"
      let deptPrefix = "dept_"
      if (roleUserTreeNode.id.startsWith(userPrefix)) {
        return Object.assign({iconSkin: "iconUser"}, roleUserTreeNode)
      } else if (roleUserTreeNode.id.startsWith(deptPrefix)) {
        if (!roleUserTreeNode.isParent)
          return Object.assign({iconSkin: "iconBuilding"}, roleUserTreeNode)
        else
          return Object.assign({iconSkin: "pIconBuilding"}, roleUserTreeNode)
      }
    }
    ,
    toUserHolderClass(shiftTeamId) {
      if (this.toUsers && this.selectShiftTeamId && this.selectShiftTeamId === shiftTeamId) {
        return "btn btn-success btn-sm";
      } else {
        return "btn btn-outline-primary btn-sm"
      }
    }
  }
}
;
</script>